import { recommendationsStateSelector } from "../recommendationsStateSelector";
import { RootState } from "../../../store";

export const recommendationAppliedFiltersSelector = (state: RootState) => {
  const recommendations = recommendationsStateSelector(state);

  return recommendations.filters;
};
